import { useMessages } from '@/base/app';

export type SignUpIndexMovePayload = {
  to: number;
};

export function useSignUpIndex(emit: (name: string, arg: SignUpIndexMovePayload) => void) {
  function next() {
    emit('move', { to: 1 });
  }

  const msgs = useMessages({ prefix: 'account.molecules.signUpIndex' });
  return {
    description: msgs.of('description'),
    index: msgs.of('index'),
    labelNext: msgs.of('next'),
    next,
  };
}
